import { Organization } from 'services/organization';
import { create } from 'zustand';

interface OrganizationState {
  organizations: Organization[];
  currentOrganization: Organization | null;
  setOrganizations: (orgs: Organization[]) => void;
  addOrganization: (org: Organization) => void;
  updateOrganization: (orgId: string, data: Omit<Organization, 'id'>) => void;
  removeOrganization: (orgId: string) => void;
  setCurrentOrganization: (org: Organization) => void;
}

const useOrganizationStore = create<OrganizationState>((set) => ({
  organizations: [],
  currentOrganization: null,
  setOrganizations: (orgs) => set({ organizations: orgs }),
  addOrganization: (org) =>
    set((state) => ({ organizations: [...state.organizations, { ...org }] })),
  updateOrganization: (orgId, data) =>
    set((state) => {
      return {
        organizations: state.organizations.map((org) => {
          if (org.id === orgId) {
            return { ...org, ...data };
          }
          return org;
        }),
      };
    }),
  removeOrganization: (orgId) =>
    set((state) => {
      return {
        organizations: state.organizations.filter((org) => org.id !== orgId),
      };
    }),
  setCurrentOrganization: (org) => set({ currentOrganization: org }),
}));

export default useOrganizationStore;
